import { IoTClient, SearchIndexCommand, DescribeThingCommand } from '@aws-sdk/client-iot';
import { IoTDataPlaneClient, UpdateThingShadowCommand } from '@aws-sdk/client-iot-data-plane';
import { REGION, AWSIOT_DATA_ENDPOINT } from '@/aws-exports';
import { thingNamePrefix } from '@/utils/const';
import { getSdkCredentials } from '@/utils/sdk';
import { errorNotify } from '@/utils/errorNotification';
import { errorMsg, warningMsg } from '@/utils/message';
import { ElNotification } from 'element-plus';
import { i18n } from '@/Lang/index';

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.tenant - ゲートウェイのID
 * @return {Promise<object[]>} モノの情報のリスト
 */
export async function getIndexThings(data) {
  let things = [];
  try {
    const sdkCredentials = await getSdkCredentials();
    // get gateway statuses filtered by tenant and area
    let command = '';
    const client = new IoTClient({ region: REGION, credentials: sdkCredentials, retryMode: 'adaptive' });
    const queryString = `shadow.desired.tenantId:${data.tenant} AND connectivity.connected:*`;
    command = new SearchIndexCommand({ queryString: queryString });
    const response = await client.send(command);
    if (response && response.things && response.things.length > 0) {
      things = response.things;
    }
  } catch {
    //
  }
  return things;
}

/*
export async function updateGWShadowArea(data) {
  let res = { status: 0 };
  try {
    const sdkCredentials = await getSdkCredentials();
    const client = new IoTDataPlaneClient({
      region: REGION,
      credentials: sdkCredentials,
      endpoint: AWSIOT_DATA_ENDPOINT[import.meta.env.MODE],
      retryMode: 'adaptive',
    });
    const thingName = `${thingNamePrefix}${data.gateway}`;
    const command = new UpdateThingShadowCommand({
      thingName: thingName,
      payload: new TextEncoder().encode(`{ "state": { "desired": { "areaId": "${data.area}" } } }`),
    });
    await client.send(command);
  } catch {
    res = { status: -9 };
    //
  }
  return res;
}
*/

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.tenantId - テナントID
 * @param {string} data.gatewayId - ゲートウェイのID
 * @param {string} data.areaId - エリアのID
 * @return {Promise<Object>} レスポンス
 */
export async function updateGWShadowTenant(data) {
  let res = { status: 0 };
  const isIotThingNameCheckNotify = () => {
    ElNotification({
      title: i18n.global.t('gateway.warning'),
      message: warningMsg.Thing_name_not_exist,
      type: 'warning',
      duration: 2000,
      customClass: 'notify',
    });
  };
  const registerGatewayFailedNotify = (data) => {
    ElNotification({
      title: i18n.global.t('gateway.error'),
      message: errorMsg.e_register_gw_failed + `: ${data.gatewayId}`,
      type: 'error',
      duration: 2000,
      customClass: 'notify',
    });
  };
  try {
    const sdkCredentials = await getSdkCredentials();
    const client = new IoTDataPlaneClient({
      region: REGION,
      credentials: sdkCredentials,
      endpoint: AWSIOT_DATA_ENDPOINT[import.meta.env.MODE],
      retryMode: 'adaptive',
    });
    const thingName = `${thingNamePrefix}${data.gatewayId}`;
    const command = new UpdateThingShadowCommand({
      thingName: thingName,
      payload: new TextEncoder().encode(
        `{ "state": { "desired": { "tenantId": "${data.tenantId}", "status": "0" } } }`
      ),
    });
    await client.send(command);
  } catch (error) {
    res = {
      status: -2,
    };
    if (error.name === 'ResourceNotFoundException') {
      isIotThingNameCheckNotify();
    } else {
      registerGatewayFailedNotify(data);
    }
  }
  return res;
}

/**
 * @param {Object} id ゲートウェイID
 * @return {Promise<Boolean>} 存在チェック
 */
export async function isIotThingNameCheck(id) {
  let isIotThingName = false;
  const isIotThingNameCheckNotify = () => {
    ElNotification({
      title: i18n.global.t('gateway.warning'),
      message: warningMsg.Thing_name_not_exist,
      type: 'warning',
      duration: 2000,
      customClass: 'notify',
    });
  };
  try {
    const sdkCredentials = await getSdkCredentials();
    const client = new IoTClient({ region: REGION, credentials: sdkCredentials });
    const thingName = `${thingNamePrefix}${id}`;
    const command = new DescribeThingCommand({
      thingName: thingName,
    });
    await client.send(command);
    isIotThingName = true;
  } catch (error) {
    if (error.name === 'ResourceNotFoundException') {
      isIotThingName = false;
      isIotThingNameCheckNotify();
    } else {
      isIotThingName = false;
      const res = {
        status: -2,
        data: [{ cause: errorMsg.e_request_failed_err }],
      };
      errorNotify(res);
    }
  }
  return isIotThingName;
}
